import React from 'react';
import { Menu, Input, Typography, Tag } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

interface ObjectItem {
  id: string;
  name: string;
  isDraft?: boolean;
}

interface ObjectListProps {
  filteredObjects: ObjectItem[];
  selectedObjectId: string;
  searchText: string;
  handleSearch: (value: string) => void;
  handleSelectObject: (key: string) => void;
}

const ObjectList: React.FC<ObjectListProps> = ({
  filteredObjects,
  selectedObjectId,
  searchText,
  handleSearch,
  handleSelectObject,
}) => {  
  return (
    <div className="w-full flex flex-col h-full overflow-hidden">
      <div className="p-4 border-b border-gray-200">
        <Title level={5} className="mb-3 text-gray-700 font-medium">对象列表</Title>
        <Input 
          placeholder="请输入" 
          prefix={<SearchOutlined />} 
          value={searchText}
          onChange={(e) => handleSearch(e.target.value)}
          className="w-full"
          size="small"
        />
      </div>
      <div className="py-2 flex flex-col flex-1 h-[calc(100vh-200px)] overflow-y-auto">
        <div className="px-4 py-1.5 bg-gray-100 mx-4 my-2 rounded text-center">
          <Text type="secondary" className="text-sm">对象</Text>
        </div>
        <div className="flex-1 pr-2">
          <Menu
            mode="inline"
            selectedKeys={selectedObjectId ? [selectedObjectId] : []}
            onSelect={(selected) => handleSelectObject(selected.key)}
            className="border-r-0 text-sm"
            items={filteredObjects.map(obj => ({
              key: obj.id,
              label: (
                <span className="flex items-center gap-1">
                  {obj.name}
                  {obj.isDraft && <Tag color="orange" className="ml-1 text-xs leading-none py-0 px-1">草稿</Tag>}
                </span>
              ),
            }))}
          />
        </div>
      </div>
    </div>
  );
};

export default ObjectList;